import React from 'react';
import { Input } from '../../../components/ui/input';
import styles from './ThemeTab.module.css';
import type { TextFieldProps } from './theme-types';

export const TextField: React.FC<TextFieldProps> = ({
  id,
  label,
  value,
  placeholder,
  onChange,
  style,
}) => (
  <div className={styles.textField}>
    <label htmlFor={id}>{label}</label>
    <Input
      id={id}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      style={style}
    />
  </div>
);
